// extracted by mini-css-extract-plugin
export default {"form":"AuthForm_form__wKrad","formForgotPassword":"AuthForm_formForgotPassword__mVEBz","formSubmit":"AuthForm_formSubmit__orbN8"};